/* eslint-disable */
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './DatePicker220.module.css';

function parseYmd(str) {
  if (!str || typeof str !== 'string') return null;
  const [y, m, d] = str.split('-').map(Number);
  if (!y || !m || !d) return null;
  const date = new Date(y, m - 1, d);
  if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) return null;
  return date;
}

function formatYmd(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function formatDisplay(date) {
  const d = String(date.getDate()).padStart(2, '0');
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const y = date.getFullYear();
  return `${d}.${m}.${y}`;
}

export default function DatePicker220({ value, onChange, max, ariaLabel }) {
  const { t } = useTranslation();
  const valueDate = parseYmd(value);
  const maxDate = parseYmd(max);

  const displayStr = valueDate ? formatDisplay(valueDate) : '';

  const canGoPrev = !!valueDate;
  const canGoNext = valueDate && maxDate ? valueDate < maxDate : !!valueDate;

  const goPrevDay = () => {
    if (!valueDate) return;
    const d = new Date(valueDate);
    d.setDate(d.getDate() - 1);
    onChange(formatYmd(d));
  };

  const goNextDay = () => {
    if (!valueDate || (maxDate && valueDate >= maxDate)) return;
    const d = new Date(valueDate);
    d.setDate(d.getDate() + 1);
    onChange(formatYmd(d));
  };

  return (
    <div className={styles.root} role="group" aria-label={ariaLabel}>
      <button
        type="button"
        className={styles.dayNavBtn}
        onClick={goPrevDay}
        disabled={!canGoPrev}
        aria-label={t('b2bDatePickerPrevDay')}
      >
        ‹
      </button>
      <span className={styles.dayDisplay}>{displayStr}</span>
      <button
        type="button"
        className={styles.dayNavBtn}
        onClick={goNextDay}
        disabled={!canGoNext}
        aria-label={t('b2bDatePickerNextDay')}
      >
        ›
      </button>
    </div>
  );
}
